import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Title } from '@angular/platform-browser';
import { environment } from './core/environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'declarabid-private';

  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle(environment.appShortName);
  }
}
